<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "percent" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 18 18'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M14.25 3.75L3.75 14.25M5.625 4.875C5.625 5.28921 5.28921 5.625 4.875 5.625C4.46079 5.625 4.125 5.28921 4.125 4.875C4.125 4.46079 4.46079 4.125 4.875 4.125C5.28921 4.125 5.625 4.46079 5.625 4.875ZM13.875 13.125C13.875 13.5392 13.5392 13.875 13.125 13.875C12.7108 13.875 12.375 13.5392 12.375 13.125C12.375 12.7108 12.7108 12.375 13.125 12.375C13.5392 12.375 13.875 12.7108 13.875 13.125Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>